/*! ******************************************************************************************************** *
 *
 * Copyright 2011-2020 Markus Schütz
 * Copyright 2025 Oidis
 *
 * SPDX-License-Identifier: BSD-2-Clause
 * The BSD-2-Clause license for this file can be found in the LICENSE.txt file included with this distribution
 * or at https://spdx.org/licenses/BSD-2-Clause.html#licenseText
 *
 * ********************************************************************************************************* */

export class CSVExporter {
    static toString(points) {
        let string = "";

        let attributes = Object.keys(points.data)
            .filter(a => a !== "normal")
            .sort((a, b) => {
                if (a === "position") {
                    return -1;
                }
                if (b === "position") {
                    return 1;
                }
                if (a === "rgba") {
                    return -1;
                }
                if (b === "rgba") {
                    return 1;
                }
            });

        let headerValues = [];
        for (let attribute of attributes) {
            let itemSize = points.data[attribute].length / points.numPoints;

            if (attribute === "position") {
                headerValues = headerValues.concat(["x", "y", "z"]);
            } else if (attribute === "rgba") {
                headerValues = headerValues.concat(["r", "g", "b", "a"]);
            } else if (itemSize > 1) {
                for (let i = 0; i < itemSize; i++) {
                    headerValues.push(`${attribute}_${i}`);
                }
            } else {
                headerValues.push(attribute);
            }
        }
        string = headerValues.join(", ") + "\n";

        for (let i = 0; i < points.numPoints; i++) {
            let values = [];

            for (let attribute of attributes) {
                let itemSize = points.data[attribute].length / points.numPoints;
                let value = points.data[attribute]
                    .subarray(itemSize * i, itemSize * i + itemSize)
                    .join(", ");
                values.push(value);
            }

            string += values.join(", ") + "\n";
        }

        return string;
    }
}
